import { useContext } from "react";
import { useAuth } from "../../contexts/session";
import processResponse from "./processResponse";


// function for fetch of method GET
const fetchGet = (auth, endpoint, includeCredentials = false, attempts = 0) => {
    let fetchOptions = {};
    
    return fetchTokenVerifier(auth, endpoint, null, fetchOptions, "GET", attempts, includeCredentials);
};


const fetchPost = (auth, endpoint, payload, includeCredentials = false, jsonStringify = true, headers = {}, attempts = 0) => {

    let fetchOptions = {}
    if(jsonStringify) {
        fetchOptions = {
            method: "POST",
            headers: {
                Accepts: "application/json",
                "Content-Type": "application/json",
                ...headers
            },
            body: JSON.stringify(payload)
        };
    }
    else {
        fetchOptions = {
            method: "POST",
            body: payload
        }

        if(Object.keys(headers).length > 0) {
            fetchOptions["headers"] = headers;
        }
    }
    
    return fetchTokenVerifier(auth, endpoint, payload, fetchOptions, "POST", attempts, includeCredentials, jsonStringify, headers);
};

const fetchTokenVerifier = async (auth, endpoint, payload, fetchOptions, fetchType, attempts, includeCredentials, jsonStringify = true, headers = {}) => {

    const [success, accessToken] = await auth.ensureAccessToken();

    if(success){
        return await fetchHelper(auth, endpoint, payload, fetchOptions, fetchType, attempts, includeCredentials, jsonStringify = true, headers = {})
    } 
    else {
        await auth.logout();
    }
};

const fetchHelper = async (auth, endpoint, payload, fetchOptions, fetchType, attempts, includeCredentials, jsonStringify = true, headers = {}) => {
    // if an access token is set, then attach it to the request headers
    fetchOptions = {
        ...fetchOptions,
        headers: {
            ...fetchOptions.headers,
            "Authorization": `Bearer ${auth.getAccessToken()}`
        }
    };
    // if you want to force credentials to be included, flag them
    if(includeCredentials){
        fetchOptions = {
            ...fetchOptions,
            credentials: "include"
        };
    }

    // determines https or http connection based on env mode: Prod vs Dev. Dev = localhost, Prod assumes a functioning SSL cert to enable a secure connection.
    const { protocol, hostname} = window.location;

    // const connectionSecurity = (process.env.REACT_APP_MODE === "PROD") ? "https" : "http" ;
    // console.log("fetchOptions", fetchOptions);
    // return fetch(`${connectionSecurity}://${process.env.REACT_APP_URL}` + endpoint, fetchOptions)
    return fetch(`${protocol}//${hostname}${(hostname === "localhost") ? ":3001" : ""}` + endpoint, fetchOptions)
    .then(res => {
        // determine how we will process the resolution
        const contentType = res.headers.get("content-type") || "";

        if(contentType.includes("application/json")){
            return {data: res.json(), resType: "json"};
        }
        
        return {data: res.blob(), resType: "blob"};
    })
    .then(async ({data, resType}) => {
        data = await data;
                
        if(resType === "json"){
            // check validity of data received
            const [valid, type] = await processResponse(auth, data.type, attempts);

            // id valid then return it
            if(valid) {
                return data;
            }
            else if(type === "refresh" || type === "refreshLanding"){
                // return is not valid and is refresh then attempt to refresh accessToken
                let refreshValid = null;
                let token = null;

                if(type === "refresh"){
                    [refreshValid, token] = await auth.refreshAccessToken();
                }
                else{
                    [refreshValid, token] = await auth.refreshAccessToken();
                }
                
                if(refreshValid && token){
                    // if refresh was successful then retry original request. Increment # of attempts too to prevent infinite retry loop
                    attempts++;
                    
                    let data = null;
                    if(fetchType === "POST"){
                        data = await fetchPost(auth, endpoint, payload, includeCredentials, jsonStringify, headers, attempts);
                    }
                    else{
                        data = await fetchGet(auth, endpoint, includeCredentials, attempts);
                    }
                    return data;
                }
                else {
                    await auth.logout();
                }
            }
        }
        else {
            if(resType === "blob"){
                return data
            }
        }
    })
    .catch(err => {
        // if fetch was bad then return err
        return err;
    });  

}

export {
    fetchGet,
    fetchPost,
};